import api from '../../../core/api/api';

const BASE = '/Contabilidad';

export const gastosFijosAPI = {
  getGastosFijos: (mes, anio) =>
    api.get(`${BASE}/GastosFijos`, { params: { mes, anio } }).then(r => r.data),

  guardarGastoFijo: ({ idCategoria, mes, anio, valor }) =>
    api.put(`${BASE}/GastosFijos`, { idCategoria, mes, anio, valor }).then(r => r.data),
};
